<template lang="pug">
v-layout.currentdailymenu(column)
    v-card.dayblock(min-height="250px" v-ripple="false"
      v-for="(item, idx) in reservationData" :key="idx"
      column)
      v-card-title.header.pb-0()
        v-row
          v-col.left(cols="6" justify-left) {{formatNameDate(item.date)}}
          v-col.right(justify-right cols="6") {{formatDate(item.date)}}
      v-row.ma-0(v-for="(dayItem, idx) in item.reservedOffers" :key="idx")
        v-card-text.pa-0.pt-0
          v-divider.pt-4(v-if="isDivider(idx)")
          v-row.ma-0
            v-col.title.text-center(cols="12" justify-right v-if="dayItem.timeBlock !== 'Obed'") {{dayItem.timeBlockTitle}}

        v-card-text.list(v-if="$vuetify.breakpoint.mdAndUp")
          v-card-title.pa-0
            v-row.ma-0
              v-col.pa-0(cols="12")
                v-alert.ma-0(
                  v-if="isAcceptanceProcess && reservationData" dense
                  icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'waitlisted' && item.status === 'active'" type="success" outlined) {{ $t('dashboardPage.orderWaitlistedAccepted') }}
                v-alert.ma-0(
                  v-if="isAcceptanceProcess && reservationData" dense
                  icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'waitlisted' && item.status === 'canceled'" type="warning" outlined) {{ $t('dashboardPage.orderWaitlistedStorno') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense  icon="fal fa-exclamation-circle" type="error" outlined v-show="item.acceptanceStatus === 'rejected' && item.status === 'canceled'") {{ $t('dashboardPage.orderRejectedStorno') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'accepted'  && item.status === 'canceled'" type="error" outlined) {{ $t('dashboardPage.orderAcceptedStorno') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense  icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'rejected' && item.status === 'active'" type="error" outlined) {{ $t('dashboardPage.orderRejectedAccepted') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense type="success" outlined icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'accepted' && item.status === 'active'") {{ $t('orderPage.orderAccepted') }}
                v-alert.ma-0(v-if="reservationData" dense  icon="fal fa-check-circle" type="success" outlined v-show="item.status === 'delivered'") {{ $t('dashboardPage.labelDeliveredOrder') }}


          v-row.list_item.ma-0.mr-0.mt-4( v-for="option in dayItem.options" :key="option.dailyMenuOffer.id")
            v-col.title.text-start(cols="3" md="2") {{option.dailyMenuOffer.menuGroupSlot.code}}
            v-col.text-start.pl-0(cols="6" md="7") {{option.dailyMenuOffer.referenceFoodItem.title}}
            v-col.text-end.pr-2(cols="3" md="3" v-if="isMultiplePortion" )
              v-btn.text-h6(fab color="grey lighten-4" small disabled) {{option.amount}}
                span.font-style x
          v-row.ma-0.row-style.mt-4(v-if="isBoarderNote && item.boarderNote !== null && item.boarderNote !== ''")
          v-row.ma-0.mb-2
            v-col.pa-0(cols="12" v-if="isBoarderNote && item.boarderNote !== null && item.boarderNote !== '' " )
              v-expansion-panels.boarder-alert-notice-style.mt-8.ma-0(accordion v-model="open" )
                v-expansion-panel.ma-0(v-ripple="false" )
                  v-expansion-panel-header.expansion-panel-header-min-height.pl-0.chip-overflow.pt-4( :style="{'white-space': 'pre-wrap'}" expand-icon="fas fa-angle-double-down" v-if="$vuetify.breakpoint.mdAndUp" )
                      v-col.pa-0.text-start.px-3(cols="auto" )
                        v-icon(color="primary" ) fas fa-info-circle
                      v-col.pa-0.text-start.chip-overflow.pr-3
                        span.text-start.chip-overflow(v-if="open !== 0") {{item.boarderNote}}
                  v-expansion-panel-content(:style="{'white-space': 'pre-wrap'}" ) {{item.boarderNote}}
        v-card-text.list.pa-0.pr-1.pl-1(v-else)
          v-card-title.pa-0
            v-row.ma-0
              v-col.pa-0(cols="12")
                v-alert.ma-0(
                  v-if="isAcceptanceProcess && reservationData" dense
                icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'waitlisted' && item.status === 'active'" type="warning" outlined ) {{ $t('dashboardPage.orderWaitlistedAccepted') }}
                v-alert.ma-0(
                  v-if="isAcceptanceProcess && reservationData" dense
                icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'waitlisted' && item.status === 'canceled'" type="warning" outlined) {{ $t('dashboardPage.orderWaitlistedStorno') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense  icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'rejected' && item.status === 'canceled'" type="error" outlined) {{ $t('dashboardPage.orderRejectedStorno') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'accepted'  && item.status === 'canceled'" type="warning" outlined) {{ $t('dashboardPage.orderAcceptedStorno') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense  icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'rejected' && item.status === 'active'" type="warning" outlined) {{ $t('dashboardPage.orderRejectedAccepted') }}
                v-alert.ma-0(v-if="isAcceptanceProcess && reservationData" dense  icon="fal fa-exclamation-circle" v-show="item.acceptanceStatus === 'accepted' && item.status === 'active'" type="success" outlined) {{ $t('orderPage.orderAccepted') }}
                v-alert.ma-0(v-if="reservationData" dense  icon="fal fa-check-circle" v-show="item.status === 'delivered'" type="success" outlined) {{ $t('dashboardPage.labelDeliveredOrder') }}

          v-row.list_item.ma-0.mr-0.mb-1.mt-4( v-for="option in dayItem.options" :key="option.dailyMenuOffer.id")
            v-col.title.text-start(cols="3" md="2") {{option.dailyMenuOffer.menuGroupSlot.code}}
            v-col.text-start.pl-0(cols="6" md="7") {{option.dailyMenuOffer.referenceFoodItem.title}}
            v-col.text-end.pr-1(cols="3" md="3" v-if="isMultiplePortion" )
              v-btn.text-h6(fab color="grey lighten-4" small disabled) {{option.amount}}
                span.font-style x
          v-row.ma-0.row-style.mt-4(v-if="isBoarderNote && item.boarderNote !== null && item.boarderNote !== ''")
          v-row.ma-0.mb-4
            v-col.pa-0(cols="12" v-if="isBoarderNote && item.boarderNote !== null && item.boarderNote !== ''")
              v-expansion-panels.boarder-alert-notice-style.mt-6.ma-0(accordion v-model="open")
                v-expansion-panel.ma-0(v-ripple="false")
                  v-expansion-panel-header.expansion-panel-header-min-height.pl-0.chip-overflow.pt-4(:style="{'white-space': 'pre-wrap'}" expand-icon="fas fa-angle-double-down" )
                    v-col.pa-0.text-start.px-3(cols="auto")
                      v-icon(color="primary" ) fas fa-info-circle
                    v-col.pa-0.text-start.chip-overflow.pr-3
                      span.text-start.chip-overflow(v-if="open !== 0") {{item.boarderNote}}
                  v-expansion-panel-content(:style="{'white-space': 'pre-wrap'}") {{item.boarderNote}}

</template>

<script lang="ts">
import Vue from 'vue'
import { CURRENT_USER_RESERVATION_RANGE_DATA, USER_LOGGED_IN } from '@/store/getter-types'
import Moment from 'moment'
import { formatAsIsoWeek } from '@/services/date-time'
import moment from 'moment'
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import {CurrentUser} from "@/model/CurrentUser";
import _, {indexOf} from "lodash";
import {Watch} from "vue-property-decorator";

export default Vue.extend({
  name: 'CurrentDailyMenu',

  props: {
    timeBlockCollection: {
      type: Array as () => BusinessTimeBlockCollection[],
      //default: DatePeriodEnum.Month
    },
    settingsData: {type: Array as () => any[]},
    currentUser: {type: Object as () => CurrentUser}

},

  watch: {
    clickOnCard(newVal: any): void {
      this.clickOnCard = newVal
    }
  },

  computed: {
    isMultiplePortion (): boolean {
      return this.currentUser.boarderList[0].customer.configuration.allow_multiple_portions

    },

    isBoarderNote(): boolean {
      return this.currentUser.boarderList[0].customer.configuration.allow_reservation_note

    },

    username (): string {
      let user = this.$store.getters[USER_LOGGED_IN]
      return user.fullName
    },

    reservationData (): any[] {
      let reservationData = this.$store.getters[CURRENT_USER_RESERVATION_RANGE_DATA]
      let currentData: any[] = []
      if (reservationData) {

        currentData = _(reservationData.reservationList)
            .groupBy('date') // Zoskupenie podľa dátumu
            .map((dateGroup, date) => {
              const groupedByTimeBlock = _(dateGroup)
                  .groupBy('timeBlock.title')
                  .map((timeBlockGroup, timeBlock) => {
                    const groupedOffers = _(timeBlockGroup)
                        .flatMap('reservedOffers')
                        .groupBy(offer => `${offer.dailyMenuOffer.referenceFoodItem.id}`) // Kľúč pre zoskupenie podľa ID jedla
                        .map((offerGroup, key) => {
                          const firstOffer = _.head(offerGroup);
                          return {
                            dailyMenuOffer: firstOffer.dailyMenuOffer,
                            amount: _.sumBy(offerGroup, 'amount') // Sčítanie amountov
                          };
                        })
                        .value();
                    return {
                      timeBlockTitle: timeBlock,
                      options: groupedOffers
                    }
                  })
                  .value();

              return {
                date: date,
                acceptanceStatus: dateGroup[0].acceptanceStatus ? dateGroup[0].acceptanceStatus.name : 'accepted',
                reservedOffers: groupedByTimeBlock,
                status: dateGroup[0].status, // Predpokladáme rovnaký status pre všetky objednávky v skupine
                boarderNote: dateGroup[0].boarderNote
              };
            })
            .value()

      }
      return currentData
    },

    isAcceptanceProcess(): boolean {
      let condition: boolean = false
      const foundItem: any = this.settingsData.find((c: any) => c.key ===  'tenant.allow_acceptance_process')
      if(foundItem){
        condition = foundItem.value === 'true'
      } else {
        condition = false
      }

      return condition
    }

  },

  methods: {

    isDivider (item: any) {
      if(item > 0) {
        return true

      }
    },

    amount (option: any): any {
      let data = this.$store.getters[CURRENT_USER_RESERVATION_RANGE_DATA]
      let foundItem: any | null = null
      let amount: any | null = null
      data.reservationList.forEach((item: any) => {
        item.reservedOffers.filter((i: any) => {
          foundItem = i.dailyMenuOffer.id === option.offer.id
          if(foundItem) {
            amount = i.amount
          }
        })

      })
      return amount
    },


    formatDate (date: Date): string {
      return Moment(date).format('D.M.Y')
    },

    formatNameDate (date: any): string {
      let tomorrow = Moment(new Date()).add(1, 'days')
      if (Moment(date).isSame(Moment(), 'day')) {
        return 'Dnes'
      } else if (Moment(date).isSame(tomorrow, 'day')) {
        return 'Zajtra'
      } else {
        return ''
      }

    },

    onDayMenuClick (date: Date): void {
      if(this.clickOnCard === true) {
        this.$router.push({
          'name': 'Order',
          params: {
            isoWeek: formatAsIsoWeek(date),
            date: moment(date).format('YYYY-MM-DD')
          }
        })
      }

    }
  },
  mounted() {
  },

  data () {
    return {
      size: '230',
      open: undefined,
      clickOnCard: true
    }
  }
})
</script>

<style lang="stylus" scoped>
.font-style
  font-size 12px
  padding-top: 5px;

.expansion-panel-header-min-height
  height 20px !important

.chip-overflow
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  padding-top 6px

.row-style
  border 0.5px dotted #d5d0d0


.boarder-alert-notice-style
  border 1px solid #1976d2

  >>> .v-alert__icon.v-icon
    color #1976d2

.right
    text-align right

.currentdailymenu
    padding 0px

    .dayblock
        margin-bottom 20px

        .name
            padding-bottom 0
            font-weight bold
            font-size 1.1em

        .list
            padding-top 0
            font-size 1.1em

            .list_item
                line-height 2em
                background-color #f5f3f3

                .code
                    margin-right 10px

            .storno
                text-align center
                padding 10px
                background-color #fadacd
                color #fadacd

            .delivered
                text-align center
                padding 10px
                background-color #95c642
                color #fadacd
</style>
